var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10248_799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0Z",
    fill: "#F26A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.95 11L26.204 30.126C26.204 30.126 26.043 31 24.959 31C24.383 31 24.086 30.726 24.086 30.726L15.972 23.993L12.002 21.992L6.907 20.637C6.907 20.637 6 20.375 6 19.625C6 19 6.933 18.702 6.933 18.702L28.249 10.234C28.249 10.234 28.9 9.999 29.375 10C29.667 10 30 10.125 30 10.5C30 10.75 29.95 11 29.95 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 26.505L15.5738 29.879C15.5738 29.879 15.4248 29.994 15.2258 29.999C15.1568 30.001 15.0828 29.99 15.0068 29.956L15.9708 23.991L18.9998 26.505Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.897 14.1959C25.728 13.9759 25.416 13.9359 25.196 14.1029L12 21.9999C12 21.9999 14.106 27.8919 14.427 28.9119C14.749 29.9329 15.007 29.9569 15.007 29.9569L15.971 23.9919L25.803 14.8959C26.023 14.7289 26.064 14.4159 25.897 14.1959Z",
    fill: "#CFD8DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10248_799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTg);
export default __webpack_public_path__ + "static/media/icon-tg.9be71677c215abf7cc188b4644345e08.svg";
export { ForwardRef as ReactComponent };